import { css } from "styled-components";

export const applyGradient = (firstColor, secondColor) => css`
    background-image: linear-gradient(315deg, ${firstColor}, ${secondColor});
`;
